import React from "react";
import {A, Dash} from "../presentational/Footer";
import Link from "next/link";

export default function MainFooterLinks(){
  return <>
    <Dash>—</Dash>
    <Link
      passHref
      href={{ pathname: '/mentions-legales'}}
      as="/mentions-legales"
    >
      <A>Mentions légales</A>
    </Link>
    <Dash>—</Dash>
    <Link
      passHref
      href={{ pathname: '/politique-de-confidentialite'}}
      as="/politique-de-confidentialite"
    >
      <A>Politique de confidentialité</A>
    </Link>
    <Dash>—</Dash>
    <Link
      passHref
      href={{ pathname: '/charte-ifprofs'}}
      as="/charte-ifprofs"
    >
      <A>Charte IFprofs</A>
    </Link>
  </>;
}
